import { useAuth } from "@clerk/clerk-react";
import { Navigate, useLocation } from "react-router-dom";
import { COLORS } from "../hooks/useAudioRecorder";

/**
 * Route guard: renders children only when Clerk reports a signed-in session.
 * Otherwise redirects to /sign-in, preserving the originally-requested URL
 * via Clerk's `redirect_url` query param so the post-signin flow returns
 * the user where they were heading.
 */
export default function RequireAuth({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) {
    return (
      <div
        style={{
          minHeight: "100dvh",
          backgroundColor: COLORS.bg,
          color: COLORS.faint,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "'JetBrains Mono', ui-monospace, monospace",
          fontSize: 12,
          letterSpacing: "0.18em",
          textTransform: "uppercase",
        }}
      >
        // loading
      </div>
    );
  }

  if (!isSignedIn) {
    const target = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/sign-in?redirect_url=${encodeURIComponent(target)}`}
        replace
      />
    );
  }

  return children;
}
